import {MUIProLicense} from "@bounce/shared/constants";
import {AuthProvider, SentryProvider} from "@bounce/shared/contexts";
import {queryClient} from "@bounce/shared/requests";
import {GlobalStyles, ProgressBarStyle, ThemeConfig, Toast} from "@bounce/shared/ui";
import NiceModal from "@ebay/nice-modal-react";
import {consumerUrls as urls} from "~/routes/consumerUrls";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LicenseInfo} from "@mui/x-license";
import {QueryClientProvider} from "@tanstack/react-query";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import {BrowserRouter} from "react-router-dom";
import {
  AmplitudeProvider,
  ConsumerUserProvider,
  LoginDestinationUrlProvider,
  WeglotProvider,
  PartnerUiProvider,
  ActivityEventProvider,
} from "./contexts";
import {WebchatStoreProvider} from "~/components/webchat/WebchatProvider";
import {WelcomeSplash} from "~/new-design/components/splash";
import DevToolsPanel from "./dev-tools/DevToolsPanel";
import Router from "./routes/routes";
import {ConsumerApiExceptionManager, ConsumerApiManager} from "~/api";
import {isDevToolsEnabled} from "@bounce/shared";

const App = () => {
  LicenseInfo.setLicenseKey(MUIProLicense);
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <LoginDestinationUrlProvider>
          <AuthProvider>
            <ConsumerApiManager>
              <PartnerUiProvider>
                <WelcomeSplash />
                <ConsumerUserProvider>
                  <WeglotProvider>
                    <SentryProvider urls={urls}>
                      <AmplitudeProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <ActivityEventProvider>
                            <ThemeConfig>
                              <Toast />
                              <GlobalStyles />
                              <ProgressBarStyle />
                              <ConsumerApiExceptionManager />
                              <WebchatStoreProvider>
                                <NiceModal.Provider>
                                  <Router />
                                </NiceModal.Provider>
                              </WebchatStoreProvider>
                            </ThemeConfig>
                          </ActivityEventProvider>
                        </LocalizationProvider>
                      </AmplitudeProvider>
                    </SentryProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                  </WeglotProvider>
                  {isDevToolsEnabled() && <DevToolsPanel />}
                </ConsumerUserProvider>
              </PartnerUiProvider>
            </ConsumerApiManager>
          </AuthProvider>
        </LoginDestinationUrlProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
